import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import { pageStyles } from "./pageStyles";
import NavBar from "./NavBar";

export default function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [guestSubmitting, setGuestSubmitting] = useState(false);

  const redirectTo = location.state?.from?.pathname || "/app";

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      await login(email, password);
      navigate(redirectTo, { replace: true });
    } catch (err) {
      setError(err.message || "Could not sign in.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div style={pageStyles.page}>
      <NavBar />
      <div style={pageStyles.authWrap}>
        <form style={pageStyles.card} onSubmit={handleSubmit}>
          <h1 style={pageStyles.title}>Sign in</h1>
          <p style={pageStyles.subtitle}>Welcome back — pick up where you left off.</p>

          <label style={pageStyles.label} htmlFor="login-email">Email</label>
          <input
            id="login-email"
            type="email"
            required
            autoComplete="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            style={pageStyles.input}
          />

          <label style={pageStyles.label} htmlFor="login-password">Password</label>
          <input
            id="login-password"
            type="password"
            required
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={pageStyles.input}
          />

          {error ? <div style={pageStyles.errorBanner}>{error}</div> : null}

          <button
            type="submit"
            disabled={submitting}
            style={{ ...pageStyles.button, ...(submitting ? pageStyles.buttonDisabled : {}) }}
          >
            {submitting ? "Signing in…" : "Sign in"}
          </button>

          <div style={pageStyles.linkRow}>
            <Link to="/forgot-password" style={pageStyles.link}>Forgot password?</Link>
            <Link to="/signup" style={pageStyles.link}>Create an account</Link>
          </div>
        </form>
      </div>
    </div>
  );
}
